import React, { useEffect, useState } from "react";
import { apiClient } from "../../../api/apiClient";
import flowerIcon from "../../../assets/img/flower_icon.png";
import "../../../assets/css/admin/organization/OrganizationAdmin.css";
import "../../../assets/css/admin/AdminCommon.css";

function Label({ children }) {
  return (
    <label className="org-label">
      <img src={flowerIcon} alt="" className="org-label-icon" />
      <span>{children}</span>
    </label>
  );
}

const DEFAULT_PRESIDENTS = [
  { position: "총학생회장", name: "", info: "" },
  { position: "부총학생회장", name: "", info: "" },
];

export default function OrgExecutive() {
  const [presidents, setPresidents] = useState(DEFAULT_PRESIDENTS);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchExecutives = async () => {
      try {
        setLoading(true);

        const result = await apiClient("/api/council/org/executives");
        const data = result?.data || [];

        if (!Array.isArray(data) || data.length === 0) {
          setPresidents(DEFAULT_PRESIDENTS);
          return;
        }

        const mappedData = data.map((item) => ({
          id: item.orgId,
          position: item.position || "",
          name: item.name || "",
          info: item.studentId || "",
        }));

        setPresidents(mappedData);
      } catch (error) {
        console.error("회장단 조회 오류:", error);
        alert(error.message || "회장단 조회 중 오류가 발생했습니다.");
        setPresidents(DEFAULT_PRESIDENTS);
      } finally {
        setLoading(false);
      }
    };

    fetchExecutives();
  }, []);

  const updatePresident = (index, key, value) => {
    setPresidents((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              [key]: value,
            }
          : item
      )
    );
  };

  const addPresident = () => {
    setPresidents((prev) => [
      ...prev,
      {
        position: "",
        name: "",
        info: "",
      },
    ]);
  };

  const deletePresident = (index) => {
    const confirmDelete = window.confirm("삭제하시겠습니까?");
    if (!confirmDelete) return;

    setPresidents((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = async () => {
    const hasEmpty = presidents.some(
      (item) =>
        !item.position.trim() || !item.name.trim() || !item.info.trim()
    );

    if (hasEmpty) {
      alert("직책, 이름, 전공/학번을 모두 입력해 주세요.");
      return;
    }

    const requestBody = presidents.map((item) => ({
      position: item.position,
      name: item.name,
      studentId: item.info,
    }));

    try {
      setLoading(true);

      const result = await apiClient("/api/council/org/executives", {
        method: "PUT",
        body: JSON.stringify(requestBody),
      });

      const savedData = result?.data || [];

      const mappedData = savedData.map((item) => ({
        id: item.orgId,
        position: item.position || "",
        name: item.name || "",
        info: item.studentId || "",
      }));

      setPresidents(mappedData.length > 0 ? mappedData : DEFAULT_PRESIDENTS);

      alert("저장되었습니다.");
    } catch (error) {
      console.error("회장단 저장 오류:", error);
      alert(error.message || "회장단 저장 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="org-inner admin-scroll-x">
      <div className="section-head">
        <h1>회장단</h1>

        <button
          className="pink-plus"
          onClick={addPresident}
          type="button"
          disabled={loading}
        >
          ＋
        </button>
      </div>

      {loading && presidents.length === 0 ? (
        <div className="org-empty">불러오는 중입니다.</div>
      ) : (
        presidents.map((item, index) => (
          <div className="president-form" key={item.id || index}>
            <div className="form-row">
              <Label>직책</Label>

              <input
                value={item.position}
                onChange={(e) =>
                  updatePresident(index, "position", e.target.value)
                }
                placeholder="직책을 입력해 주세요."
              />
            </div>

            <div className="form-row">
              <Label>이름</Label>

              <input
                value={item.name}
                onChange={(e) => updatePresident(index, "name", e.target.value)}
                placeholder="이름을 입력해 주세요."
              />
            </div>

            <div className="form-row">
              <Label>전공/학번</Label>

              <input
                value={item.info}
                onChange={(e) => updatePresident(index, "info", e.target.value)}
                placeholder="전공/학번을 입력해 주세요."
              />
            </div>

            <button
              className="small-delete"
              onClick={() => deletePresident(index)}
              type="button"
              disabled={loading}
            >
              삭제
            </button>
          </div>
        ))
      )}

      <div className="save-btn-wrap">
        <button
          className="save-btn"
          onClick={handleSave}
          type="button"
          disabled={loading}
        >
          {loading ? "저장 중..." : "저장"}
        </button>
      </div>
    </section>
  );
}